/**
 * Integration tests page route. The page itself lives in
 * client/src/components/admin-console/integration-tests/.
 */

import { PageController } from '@client/components/_core/layout/PageController';
import { IntegrationTestsPage } from '@client/components/admin-console/integration-tests/IntegrationTestsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/advanced/integration-tests')({
    staticData: {
        ui: {
            title: 'Integration tests',
            menuDescription: 'Test external service connectivity',
        },
        breadcrumb: { title: 'Integration tests' },
    },
    component: IntegrationTestsRoute,
});

function IntegrationTestsRoute() {
    return (
        <PageController route={Route}>
            <IntegrationTestsPage />
        </PageController>
    );
}
